export const iife = <TReturn>(callback: () => TReturn) => callback();
